import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  formControlLabel: {
    fontWeight: theme.typography.fontWeightLight
  },
  previewEmailContent: {
    border: `1px solid ${theme.palette.grey.A200}`,
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2)
  }
}));
